import { html } from '@webtides/element-js';
import SpecFilter from '../spec-filter/SpecFilter';

import listStyles from './spec-list-filter.css';
export default class SpecListFilter extends SpecFilter {
    events() {
        return Object.assign(super.events(), {
            button: {
                click: e => {
                    const { index } = e.currentTarget.dataset;
                    this.changeSelection(index);
                },
            },
        });
    }

    styles() {
        return [listStyles];
    }

    activeIndicator(active) {
        return html`
            <div class="active-indicator text-brand-500 ml-4 ${active ? 'block' : 'hidden'}">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14">
                    <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M13.3329965,19.5369965 L23.2702348,10.2215838 C23.7001422,9.81854562 24.375378,9.84032742 24.7784162,10.2702348 C25.1526659,10.6694345 25.1606168,11.2801674 24.8156353,11.6880732 L24.7297652,11.7784162 L13.9991184,21.8339744 L13.9991184,21.8339744 L13.9071492,21.8998727 L13.9071492,21.8998727 L13.800668,21.9595323 L13.800668,21.9595323 L13.6938679,22.0044824 L13.6938679,22.0044824 L13.5931656,22.0350208 L13.5931656,22.0350208 L13.476095,22.0574476 L13.476095,22.0574476 L13.3979384,22.0651037 L13.3979384,22.0651037 L13.2697055,22.0651037 L13.2697055,22.0651037 L13.1281743,22.0472281 L13.1281743,22.0472281 L13.0472123,22.0280829 L13.0472123,22.0280829 L12.9396387,21.9919835 L12.9396387,21.9919835 L12.8669716,21.9600014 L12.8669716,21.9600014 L12.766664,21.9043245 L12.766664,21.9043245 L12.7242108,21.8763143 L12.7242108,21.8763143 L12.6697569,21.8357374 C12.6295303,21.8037153 12.5911253,21.7683872 12.5549171,21.7297652 L12.6269965,21.7979965 L12.6035681,21.7784162 L7.27023482,16.7784162 C6.84032742,16.375378 6.81854562,15.7001422 7.2215838,15.2702348 C7.59583354,14.8710351 8.2047843,14.8237396 8.63407575,15.1417147 L8.72976518,15.2215838 L13.3329965,19.5369965 L23.2702348,10.2215838 L13.3329965,19.5369965 Z"
                        transform="translate(-6 -9)"
                    />
                </svg>
            </div>
        `;
    }

    renderValues() {
        return this.values.map((value, index) => {
            return html`
                <button
                    class="flex items-center text-left w-full p-4 border-b focus:outline-none ${this.disabled.includes(
                        index
                    )
                        ? 'text-grey-200'
                        : ''}"
                    data-index="${index}"
                    ?disabled="${this.disabled.includes(index)}"
                >
                    <div>${value.label}</div>
                    ${this.activeIndicator(!!this.values[index].selected)}
                </button>
            `;
        });
    }
}
